import React from 'react';

const AdminProducts = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Products Management</h1>
      <p>Manage your products here</p>
    </div>
  );
};

export default AdminProducts;